import { shuffle } from '~/utils'
import { randomIntFromInterval } from '~/bootcamp/Activities/utils/activities.utils'

import { GROUPS } from './Constants'

/**
 * It generates a list of image sources for a pizza with a given denominator and numerator
 * @param {number} denominator - the number of pieces the pizza is cut into
 * @param {number} numerator - the number of pieces of pizza that are shown
 * @param {number[]} groupHistory - history of group
 * @returns A object with list of image sources, selected group index and selected item index
 */
export function generateImageSrcListAndGroupIndex(
  denominator: number,
  numerator: number,
  groupHistory: number[],
): { imageSrcList: string[]; groupIndex: number; selectedItemIndex: number } {
  let imageSrcList: string[] = []
  const groupIndex = randomIntFromInterval(0, GROUPS.length - 1, groupHistory)
  const selectedItemIndex = randomIntFromInterval(0, 1)
  let itemIndexes: number[] = Array(denominator).fill(0)

  itemIndexes.forEach((item, index) => {
    itemIndexes[index] = index < numerator ? selectedItemIndex : 1 - selectedItemIndex
  })
  itemIndexes = shuffle(itemIndexes)
  itemIndexes.forEach((item) => {
    imageSrcList = [...imageSrcList, GROUPS[groupIndex].items[item].srcKey]
  })
  return { imageSrcList, groupIndex, selectedItemIndex }
}
